export default {
	format(number: number) {
		return new Intl.NumberFormat().format(number)
	},
}